import React, { useContext, useMemo } from 'react';
import { SidekickDataGridConfigContextProvider } from '../../../../../context/SidekickDataGridConfigContext';
import { ColumnGroup } from '../../helpers/GridColumns';

const ImportedProductsColumnsWrapper = ({ children }: { children: JSX.Element }) => {

  const columnVisibility = useMemo(
    () => ({
      name: true,
      description: true,
      categoryId: true,
      salePriceIncTax: true,
    }),
    []
  );

  const columnGroups: ColumnGroup[] = useMemo(
    () => [
      {
        name: 'generic',
        entries: ['name', 'description', 'categoryId'],
      },
      {
        name: 'price',
        entries: ['salePriceIncTax'],
      },
    ],
    []
  );

  return (
    <SidekickDataGridConfigContextProvider
      translationKey="csvColumns"
      columnVisibility={columnVisibility}
      columnGroups={columnGroups}
    >
      {children}
    </SidekickDataGridConfigContextProvider>
  );
};
export default ImportedProductsColumnsWrapper;
